import React from 'react';
import { ArrowRightIcon, ArrowDownIcon } from 'lucide-react';
import { HOW_IT_WORKS } from '../../data/homeContent';
import { PRODUCT_SCREENSHOTS } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { StepImage } from '../dgpt/product/StepImage';
import { VideoFacade } from '../dgpt/VideoFacade';
export function HowItWorksSection() {
  return <section id="how-it-works" aria-labelledby="how-heading" className="scroll-mt-20 border-b border-hairline-soft bg-ink" data-id="element-176" data-mp="22dj1s2h3n75o">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-177" data-mp="1xf7qdnb5oolc">
        <SectionHeading eyebrow="How it works" headingId="how-heading" title="Your documents. Your criteria. A structured assessment." data-id="element-178" data-mp="2c3uhema5b4se" />

        <ol className="mt-12 grid gap-3 lg:grid-cols-[1fr_auto_1fr_auto_1fr] lg:items-stretch" data-id="element-179" data-mp="2l63qr8togs47">
          {HOW_IT_WORKS.map((step, index) => <React.Fragment key={step.title} data-id="element-180" data-mp="2h1dwtpikxnlx" data-mpi={index}>
              <Reveal as="li" delay={index * 0.06} className="flex flex-col rounded-2xl border border-hairline bg-panel p-6" data-id="element-181" data-mp="1rnq66dc7g89g">
                <div className="flex items-center justify-between" data-id="element-182" data-mp="1vp1wym6tezj8">
                  <span className="font-mono text-xs text-lime" data-id="element-183" data-mp="20nd6swx41a1g">STEP 0{index + 1}</span>
                  <span className="rounded-md bg-elevated px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.08em] text-text-secondary" data-id="element-184" data-mp="25n9124g09n3t">
                    {step.label}
                  </span>
                </div>
                <h3 className="mt-4 text-lg font-semibold tracking-[-0.015em] text-text-primary" data-id="element-185" data-mp="2emcn9hagyimj">{step.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-text-secondary" data-id="element-186" data-mp="2jenxbcyxbkst">{step.body}</p>
                <ul className="mt-5 flex flex-wrap gap-1.5" aria-label={`${step.label} examples`} data-id="element-187" data-mp="2ocpgrz09hm4t">
                  {step.chips.map(chip => <li key={chip} className="rounded-md border border-hairline-soft bg-surface px-2 py-1 text-[11px] text-text-secondary" data-id="element-188" data-mp="2yb55jvbtgjb5">
                      {chip}
                    </li>)}
                </ul>
              </Reveal>
              {index < HOW_IT_WORKS.length - 1 ? <li aria-hidden="true" className="flex items-center justify-center py-1 text-text-tertiary" data-id="element-189" data-mp="2idknuj1j23f8">
                  <ArrowDownIcon className="h-4 w-4 lg:hidden" data-id="element-190" data-mp="2dm2izjwdvioz" />
                  <ArrowRightIcon className="hidden h-4 w-4 lg:block" data-id="element-191" data-mp="2rdqx1sq70h8l" />
                </li> : null}
            </React.Fragment>)}
        </ol>

        <div className="mt-14 grid gap-6 lg:grid-cols-2" data-id="element-192" data-mp="2meeal938hc6j">
          <Reveal className="min-w-0" data-id="element-193" data-mp="31c6ojwt4tsim">
            <h3 className="mb-3 text-xs font-semibold uppercase tracking-[0.1em] text-text-secondary" data-id="element-194" data-mp="31b5d3r87f40d">Set your criteria</h3>
            <StepImage image={PRODUCT_SCREENSHOTS.thesis} data-id="element-195" data-mp="2waziq3ajv3el" />
          </Reveal>
          <Reveal delay={0.06} className="min-w-0" data-id="element-196" data-mp="16y5ppbxl15ij">
            <h3 className="mb-3 text-xs font-semibold uppercase tracking-[0.1em] text-text-secondary" data-id="element-197" data-mp="11zcfbsdlduml">Watch the product overview</h3>
            <VideoFacade data-id="element-198" data-mp="3dmo9armj3mnh" />
          </Reveal>
        </div>
      </div>
    </section>;
}